export default {
  input: {},
}
